// react
import Head from 'next/head';
import React from 'react';
// application
import BlockSpace from '~/components/blocks/BlockSpace';
import BlogFooterNavigator from '~/components/blocks/BlogFooterNavigator';
import AppImage from '~/components/shared/AppImage';
import AppLink from '~/components/shared/AppLink';
import Decor from '~/components/shared/Decor';
import PageTitle from '~/components/shared/PageTitle';

function Page() {
    return (
        <React.Fragment>
            <Head>
                <meta
                    property="og:title"
                    content="V-Motive: Best Automotive spare parts brand dealing in OEM, OES and V-Motive branded parts"
                />
                <meta
                    name="description"
                    content="V-Motive is a modern day spares parts brand in collaboration with various suppliers, dealers and OEMs. V-Motive has already established a strong footprint in the Indian Market and has delivered after-sales Spare Parts across 100+ cities in India."
                />
            </Head>
            <PageTitle>Vmotive: High-Quality Engine Oils for Your Car</PageTitle>

            <div className="block post-view">
                <div className="post-view__header post-header post-header--has-image">
                    <div className="post-header__image" style={{ backgroundImage: "url('/images/about.jpg')" }} />

                    <div className="post-header__body">
                        <h1 className="post-header__title">Vmotive: High-Quality Engine Oils for Your Car</h1>
                        <div className="post-header__meta">
                            <ul className="post-header__meta-list">
                                <li className="post-header__meta-item">By Vikash Sharma</li>
                                <li className="post-header__meta-item">November 30, 2021</li>
                            </ul>
                        </div>
                    </div>
                    <Decor type="bottom" className="post-header__decor" />
                </div>
            </div>

            <div className="container">
                <div className="post-view__body">
                    <div className="post-view__item post-view__item-post">
                        <div className="post-view__card post">
                            <div className="post__body typography">
                                <p>
                                    Engine oil is a crucial component in keeping your car running smoothly. It acts as a
                                    lubricant for the various moving parts in the engine, helping to reduce friction and
                                    wear. Choosing the right type of engine oil for your car is essential for
                                    maintaining its performance and longevity.
                                </p>
                                <blockquote>
                                    Vmotive is a reputable brand in the automotive industry known for producing
                                    high-quality engine oils. Their oils come in different types, each designed to meet
                                    the specific needs of different types of vehicles and driving conditions.
                                </blockquote>

                                <p>
                                    <h2>Types of Vmotive Engine Oils</h2>
                                    <br />
                                    <li>
                                        <strong> Conventional oil:</strong> This is the most common type of engine oil
                                        and is suitable for most cars. It is a mineral-based oil and can be used in both
                                        gasoline and diesel engines.
                                    </li>
                                    <li>
                                        <strong>Synthetic oil:</strong> This is a man-made oil that is designed to
                                        perform better in extreme temperatures and conditions. It is commonly used in
                                        high-performance vehicles and in colder climates.
                                    </li>
                                    <li>
                                        <strong>Synthetic blend oil:</strong> A combination of conventional and
                                        synthetic oils, synthetic blend oils offer the best of both worlds, providing
                                        the enhanced performance of synthetic oil with the more affordable price of
                                        conventional oil.
                                    </li>
                                </p>

                                <h3>Features of Vmotive Engine Oils</h3>
                                <p>
                                    <ul>
                                        <li>
                                            <strong> Excellent wear and tear protection:</strong> Formulated with
                                            high-quality base stocks and advanced additive technology to ensure maximum
                                            engine protection and performance.
                                        </li>
                                        <li>
                                            <strong> Maintains viscosity:</strong> ability to maintain their viscosity,
                                            or thickness, over a wide range of temperatures. This is important because
                                            it ensures that the oil will continue to provide proper lubrication even in
                                            extreme conditions.
                                        </li>

                                        <li>
                                            <strong> Excellent cleaning properties:</strong> help to keep your engine
                                            free of dirt and debris, extending the life of your engine and improve its
                                            overall performance.
                                        </li>
                                    </ul>
                                </p>

                                <figure>
                                    <AppLink href="/">
                                        <AppImage src="/images/product/MettlePlus.png" />
                                    </AppLink>
                                    <figcaption>Vmotive Heavy Duty Engine Oils </figcaption>
                                </figure>

                                <p>
                                    <h3>Quality of Vmotive Engine Oils</h3>
                                    <ul>
                                        <li>
                                            Vmotive engine oils are manufactured to meet or exceed industry standards
                                            and are backed by rigorous testing and quality control.
                                        </li>
                                        <li>
                                            Vmotive has a team of expert chemists and engineers who work to develop
                                            advanced lubricants that provide superior protection and performance.
                                        </li>

                                        <li>
                                            Vmotive`s commitment to quality is evident in their products, ensuring that
                                            customers are getting the best possible product for their car.
                                        </li>
                                    </ul>
                                </p>
                                <hr />
                                <p>
                                    In conclusion, choosing the right engine oil for your car is essential for
                                    maintaining its performance and longevity. Vmotive offers a range of high-quality
                                    oils that are designed to meet the specific needs of different types of vehicles and
                                    driving conditions. With their excellent wear and tear protection, ability to
                                    maintain viscosity, and excellent cleaning properties, Vmotive engine oils are a
                                    great choice for keeping your car running smoothly.
                                </p>
                            </div>
                        </div>
                        {BlogFooterNavigator(5)}
                    </div>
                </div>
            </div>

            <BlockSpace layout="divider-xl" />

            <BlockSpace layout="divider-xl" />
        </React.Fragment>
    );
}

export default Page;
